import React, { Component } from "react";
import Select from "react-select";
import { close } from "../../icons";

const availableChannels = [
	{
		"value": "fb_post",
		"label": "Facebook"
	},
	{
		"value": "tweet",
		"label": "Twitter"
	},
	{
		"value": "linkedin",
		"label": "Linkedin"
	},
	{
		"value": "newsletter",
		"label": "Newsletter"
	},
	// {
	// 	"value": "youtube",
	// 	"label": "Youtube"
	// },
	{
		"value": "pushmessage",
		"label": "Push notification"
	},
	{
		"value": "homepage_link",
		"label": "Homepage"
	}
	// {
	// 	"value": "tentaclePage_link",
	// 	"label": "Tentacle Page"
	// },
	// {
	// 	"value": "site_link",
	// 	"label": "Site link"
	// },
	// {
	// 	"value": "video",
	// 	"label": "Video"
	// },
	// {
	// 	"value": "googleTrends",
	// 	"label": "Google trends"
	// }
];

const availableValues = [
	{ value: "1", label: 'true' }, 
	{ value: "0", label: 'false' }
];

type Props = {
	isEdit: boolean,
	postedOnChannels: { channel: string, value: boolean }[],
	isDisabled: boolean,
	updateConfig: Function
}

type Option = {
	value: string;
	label: string;
};

type State = {
	postedOnChannels: { channel: string, value: boolean | null }[]
}

class PostedOnChannel extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			postedOnChannels: [
				{ channel: '', value: null }
			]
		};

		this.addPostedOnChannel = this.addPostedOnChannel.bind(this);
		this.onChannelNameChange = this.onChannelNameChange.bind(this);
		this.updatePostedOnChannels = this.updatePostedOnChannels.bind(this);
	}

	static defaultProps = {
		isDisabled: false
	}

	componentDidMount() {
		if (this.props.isDisabled) {
			this.updatePostedOnChannels([], false);
		} else {
			const initialValue = !Array.isArray(this.props.postedOnChannels) || this.props.postedOnChannels.length === 0 
				? [{ channel: '', value: null }] 
				: this.props.postedOnChannels;

			this.updatePostedOnChannels(initialValue, false);
			
		}
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.isDisabled === false && this.props.isDisabled === true) {
			this.updatePostedOnChannels([]);
		}
	}

	addPostedOnChannel() {
		if (this.props.isDisabled) {
			return;
		}

		const postedOnChannels = [...this.state.postedOnChannels];
		postedOnChannels.push({ channel: '', value: null });

		this.updatePostedOnChannels(postedOnChannels);
	}

	deletePostedOnChannel(index: number) {
		const postedOnChannels = [...this.state.postedOnChannels];
		postedOnChannels.splice(index, 1);

		this.updatePostedOnChannels(postedOnChannels);
	}

	onChannelNameChange(index: number, channelName: string | null) {
		if (channelName !== null) {
			const postedOnChannels = [...this.state.postedOnChannels];

			postedOnChannels[index] = {
				channel: channelName,
				value: postedOnChannels[index].value
			};
	
			this.updatePostedOnChannels(postedOnChannels);
		}
	}

	onChannelValueChange(index: number, value: string | null) {
		if (value !== null) {
			const postedOnChannels = [...this.state.postedOnChannels];
			postedOnChannels[index] = {
				value: value === '1',
				channel: postedOnChannels[index].channel
			};

			this.updatePostedOnChannels(postedOnChannels);
		}
	}

	updatePostedOnChannels(newPostedOnChannels: { channel: string, value: boolean | null }[], shouldUpdateConfig: boolean = true) {
		this.setState({ postedOnChannels: newPostedOnChannels }, () => {
			if (shouldUpdateConfig) {
				const filteredPostedOnChannels = newPostedOnChannels.filter(postedOnChannel => {
					return postedOnChannel.channel !== '' && postedOnChannel.value !== null;
				});
				
				this.props.updateConfig(['posted_on_channels'], [filteredPostedOnChannels]);
			}
		});
	}

	getChannelNameOptions() {
		return availableChannels;
	}

	getChannelValueOptions() {
		return availableValues;
	}

	render() {
		const postedOnChannelsLenght = this.state.postedOnChannels.length;

		return (
			<div className="config-item__posted-on-channels">
				<label>Posted on channel: </label>
				{
					this.state.postedOnChannels.map((postedOnChannel, index) => (
						<React.Fragment key={index}>
							<div className="config-item__posted-on-channel-selects">
								<div className="form-group">
									<Select
										id={`posted-channel-${index}`}
										className="basic-single"
										classNamePrefix="so-select-sort"
										isSearchable={true}
										value={this.getChannelNameOptions().find(option => option.value === postedOnChannel.channel) || null}
										options={this.getChannelNameOptions()}
										onChange={(option: Option | null) => this.onChannelNameChange(index, option!.value)}
										menuPortalTarget={document.body}
										styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
									/>
								</div>

								{/* {
									postedOnChannel.channel !== '' && (
										<React.Fragment> */}
											<div className="config-item__posted-on-channel-operator">
												is equal to
											</div>

											<div className="form-group config-item__posted-on-channel-value">
												<Select
													id={`posted-channel-value-${index}`}
													className="basic-single"
													classNamePrefix="so-select-sort"
													value={postedOnChannel.value !== null ? (postedOnChannel.value ? { value: "1", label: 'true' } : { value: "0", label: 'false' }) : null}
													options={this.getChannelValueOptions()}
													onChange={(option: Option | null) => this.onChannelValueChange(index, option!.value)}
													menuPortalTarget={document.body}
													styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
													isDisabled={postedOnChannel.channel === ''}
												/>
											</div>
										{/* </React.Fragment>
									)
								} */}

								<div className="config-item__posted-on-channel-delete" onClick={() => this.deletePostedOnChannel(index)} >
									{close}
								</div>
							</div>

							{
								index !== postedOnChannelsLenght - 1 && (
									<div className="config-item__posted-on-channel-and">
										<hr />
										<div>AND</div>
									</div>
								)
							}
						</React.Fragment>
					))
				}

				<div>
					<button className={`btn btn-outline-primary config-item__posted-on-channel-add ${postedOnChannelsLenght === 0 ? "empty" : ""} ${this.props.isDisabled ? "disabled" : ""}`} onClick={this.addPostedOnChannel} >
						<span>+</span>
					</button>
				</div>
			</div>
		);
	}
}


export default PostedOnChannel;